export const quickbooksEn = {
  QUICKBOOKS_ENTRY_AUDIT: 'QuickBooks Entry Audit',
  PUSH_TO_QUICKBOOKS: 'Push to Quickbooks',
  TIME: 'Time',
  PUBLISHED_DATE: 'Published Date',
  TRIGGERED_BY: 'Triggered by',
  ERRORS: 'Errors',
  JOURNAL_SETUP: 'Journal Setup',
  QUICKBOOK_SETUP: 'Quickbooks Setup',
  TANK_SETUP: 'Tank Setup',
  GMAIL_SETTINGS: 'Gmail Settings',
  ACCOUNT_NO: 'Account No',
  TYPE: 'Type',
  QUICKBOOKS_ONLINE: 'Quickbooks Online',
  ADD_EXTERNAL_LEDGER: 'Add Ledger',
  QUICKBOOKS_ONLINE_SETUP: 'Quickbooks Online Setup',
  TANK_ONLINE_SETUP: 'Tank Online Setup',
  INTEGRATE_QUICKBOOKS: 'Integrate FactorCloud with Quickbooks Accounts.',
  INTEGRATE_TANK: 'Integrate FactorCloud with Tank Accounts.',
  INTEGRATE_BANKSHOT: 'Integrate FactorCloud with Bankshot.',
  AUTHORIZE_SETUP: 'Authorize Setup',
  AUTHORIZE: 'Authorize',
  AUTHORIZED: 'Authorized',
  CREATE_LEDGER: 'Create Ledger',
  UPDATE_LEDGER: 'Update Ledger',
  EXPORT_LABEL: 'Export Label',
  WEIGHT: 'Weight',
  ASSIGNED_ACCOUNTS: 'Assigned Account',
  AUDIT_START_DATE: 'Audit Start Date',
  AUDIT_END_DATE: 'Audit End Date',
  RECORDS: 'Records',
  LEDGER_CREATE_INFO: 'Ledger Association updated successfully!',
  QUICKBOOK_EXPIRE_INFO: 'Quickbooks Authorization has expired, please authorize to view the Journal!',
  AUTHORIZE_QUICKBOOK_SETUP: 'Authorize Quickbooks Setup',
  UNASSIGN: 'Unassign',
  ASSIGN: 'Assign',
  EXPIRED: 'EXPIRED',
  QUICKBOOK_CLIENT_ID: 'Quickbook client Id',
  QUICKBOOK_CLIENT_SECRET: 'Quickbook client Secret',
  PERUSE_MESSAGE: 'AI-powered document review.',
  TRIUMPH_MESSAGE: 'Presentment, Audit and Payment in one convenient place.',
  TRIUMPH_CONFIGURE: 'Configure',
  TRIUMPH_CONFIGURE_TITLE: 'Triumph Configuration',
  TRIUMPH_CONFIGURE_SUBTITLE:
    'Control how non-transportation clients and debtors are reported to Triumph and review sync status for both.',
  TRIUMPH_STATUS_TRANSPORTATION_ONLY: 'Transportation only',
  TRIUMPH_STATUS_ALL_INDUSTRIES: 'All industries (beta)',
  TRIUMPH_STATUS_DEBTORS_ALL_INDUSTRIES: 'Debtors: all industries (beta)',
  TRIUMPH_STATUS_CLIENTS_ALL_INDUSTRIES: 'Clients: all industries (beta)',
  TRIUMPH_SEND_ALL_INDUSTRIES_LABEL: 'Send non-transportation debtors as "other"',
  TRIUMPH_SEND_ALL_INDUSTRIES_CLIENTS_LABEL: 'Send non-transportation clients as "other"',
  TRIUMPH_SEND_ALL_INDUSTRIES_BETA_NOTICE:
    'Beta — when on, debtors whose industry is not Transportation are reported to Triumph with type "other" instead of "broker".',
  TRIUMPH_SEND_ALL_INDUSTRIES_CLIENTS_BETA_NOTICE:
    'Beta — when on, clients whose industry is not Transportation are reported to Triumph with type "other" instead of "carrier". Independent from the debtors toggle above.',
  TRIUMPH_SEND_ALL_INDUSTRIES_UPDATED: 'Triumph configuration updated',
  TRIUMPH_SEND_ALL_INDUSTRIES_UPDATE_FAILED: 'Failed to update Triumph configuration',
  TRIUMPH_SEND_ALL_INDUSTRIES_UNSAVED: 'Unsaved changes — press Save to apply.',
  TRIUMPH_SAVE: 'Save',
  TRIUMPH_SAVE_DIALOG_TITLE: 'Save Triumph settings',
  TRIUMPH_SAVE_DIALOG_BODY:
    'Any toggle turned on will immediately re-submit its eligible GENERAL clients/debtors to Triumph with type "other" in the background. Turning a toggle off does NOT revert entities already sent — they remain as "other" on Triumph until manually edited or re-synced.',
  TRIUMPH_SAVE_DIALOG_CONFIRM: 'Continue',
  TRIUMPH_SYNC_STATUS_TITLE: 'Sync status',
  TRIUMPH_TAB_CLIENTS: 'Clients',
  TRIUMPH_TAB_DEBTORS: 'Debtors',
  TRIUMPH_TABLE_NAME: 'Name',
  TRIUMPH_TABLE_INDUSTRY: 'Industry',
  TRIUMPH_TABLE_TRIUMPH_ID: 'Triumph ID',
  TRIUMPH_TABLE_STATUS: 'Status',
  TRIUMPH_TABLE_FAILURE_DATE: 'Last failure',
  TRIUMPH_TABLE_REASON: 'Reason',
  TRIUMPH_TABLE_EMPTY: 'No sync attempts yet.',
  TRIUMPH_TABLE_LOAD_ERROR: 'Failed to load sync status. Retry from the network tab if it persists.',
  FACTOR_GENIE_MESSAGE: 'The Free App for Freight Factors.',
  ANSONIA_MESSAGE: 'Leading credit reporting company.',
  OVERPASS_MESSAGE: 'FactorGenie Credit data on the Debtor Overpass tab.',
  INTEGRATION_AUTHORIZED: 'Integration Authorized',
  INTEGRATIONS: 'Integrations',
  GMAIL_INTEGRATION: 'Gmail Integration',
  GMAIL_ACCOUNT: 'Gmail Account',
  QUICKBOOKS_PUSH_CONFIRMATION_TITLE: 'Confirm Push to Quickbooks',
  QUICKBOOKS_PUSH_RANGE_MESSAGE: 'This push will cover the following range in the factor timezone:',
  QUICKBOOKS_PUSH_FIRST_RANGE_MESSAGE: 'This is the first push. It will include all eligible records through:',
  QUICKBOOKS_PUSH_ONCE_PER_DAY: 'This push can only be done once a day.',
  QUICKBOOKS_FIRST_PUSH_START: 'Earliest available record',
  QUICKBOOKS_LAST_PUSH_BADGE: 'Last push',
  QUICKBOOKS_ALREADY_PUSHED_TODAY: 'Quickbooks has already been pushed today for this factor.',
  QUICKBOOKS_PUSH_CURRENCY_REQUIRED:
    "You can't push to Quickbooks while \"All Currencies\" is selected. Please select a specific currency in the currency filter to continue.",
  ATOB_ONLINE_SETUP: 'AtoB Online Setup',
  ATOB_DESCRIPTION: 'AtoB is a modern financial services for transportation. Instant and secure payments.',
  ATOB_ENABLED: 'AtoB integration enabled.',
}

export const quickbooksEs: typeof quickbooksEn = {
  QUICKBOOKS_ENTRY_AUDIT: 'Auditoría de entrada de QuickBooks',
  PUSH_TO_QUICKBOOKS: 'Enviar a Quickbooks',
  TIME: 'Tiempo',
  PUBLISHED_DATE: 'Fecha de Publicación',
  TRIGGERED_BY: 'Desencadenado por',
  ERRORS: 'Errores',
  JOURNAL_SETUP: 'Configuración del diario',
  QUICKBOOK_SETUP: 'Configuración de Quickbooks',
  TANK_SETUP: 'Integración de pago de Tank',
  GMAIL_SETTINGS: 'Configuración de Gmail',
  ACCOUNT_NO: 'Número de cuenta',
  TYPE: 'Tipo',
  QUICKBOOKS_ONLINE: 'Libros rápidos en línea',
  ADD_EXTERNAL_LEDGER: 'Agregar libro mayor',
  QUICKBOOKS_ONLINE_SETUP: 'Configuración de Quickbooks en línea',
  TANK_ONLINE_SETUP: 'Configuración de Tank en línea',
  INTEGRATE_QUICKBOOKS: 'Integre FactorCloud con cuentas de Quickbooks.',
  INTEGRATE_TANK: 'Integre FactorCloud con cuentas de Tank.',
  INTEGRATE_BANKSHOT: 'Integre FactorCloud con Bankshot.',
  AUTHORIZE_SETUP: 'Autorizar configuración',
  AUTHORIZE: 'Autorizar',
  AUTHORIZED: 'Autorizado',
  CREATE_LEDGER: 'Crear libro mayor',
  UPDATE_LEDGER: 'Actualizar libro mayor',
  EXPORT_LABEL: 'Etiqueta de exportación',
  WEIGHT: 'Peso',
  ASSIGNED_ACCOUNTS: 'Cuenta asignada',
  AUDIT_START_DATE: 'Fecha de inicio de la auditoría',
  AUDIT_END_DATE: 'Fecha de finalización de la auditoría',
  RECORDS: 'Registros',
  LEDGER_CREATE_INFO: '¡La Asociación de contabilidad se actualizó correctamente!',
  QUICKBOOK_EXPIRE_INFO: 'La autorización de Quickbooks ha caducado. ¡Autorice para ver el diario!',
  AUTHORIZE_QUICKBOOK_SETUP: 'Autorizar la configuración de Quickbooks',
  UNASSIGN: 'Desasignar',
  ASSIGN: 'Asignar',
  EXPIRED: 'VENCIÓ',
  QUICKBOOK_CLIENT_ID: 'ID de cliente de Quickbook',
  QUICKBOOK_CLIENT_SECRET: 'Secreto del cliente de Quickbook',
  PERUSE_MESSAGE: 'Revisión de documentos impulsada por IA.',
  TRIUMPH_MESSAGE: 'Presentación, auditoría y pago en un solo lugar conveniente.',
  TRIUMPH_CONFIGURE: 'Configurar',
  TRIUMPH_CONFIGURE_TITLE: 'Configuración de Triumph',
  TRIUMPH_CONFIGURE_SUBTITLE:
    'Controlá cómo se reportan a Triumph los clientes y deudores que no son de transporte, y revisá el estado de sincronización de ambos.',
  TRIUMPH_STATUS_TRANSPORTATION_ONLY: 'Solo transporte',
  TRIUMPH_STATUS_ALL_INDUSTRIES: 'Todas las industrias (beta)',
  TRIUMPH_STATUS_DEBTORS_ALL_INDUSTRIES: 'Deudores: todas las industrias (beta)',
  TRIUMPH_STATUS_CLIENTS_ALL_INDUSTRIES: 'Clientes: todas las industrias (beta)',
  TRIUMPH_SEND_ALL_INDUSTRIES_LABEL: 'Enviar deudores no-transporte con tipo "other"',
  TRIUMPH_SEND_ALL_INDUSTRIES_CLIENTS_LABEL: 'Enviar clientes no-transporte con tipo "other"',
  TRIUMPH_SEND_ALL_INDUSTRIES_BETA_NOTICE:
    'Beta — cuando está activado, los deudores cuya industria no es Transporte se reportan a Triumph con tipo "other" en lugar de "broker".',
  TRIUMPH_SEND_ALL_INDUSTRIES_CLIENTS_BETA_NOTICE:
    'Beta — cuando está activado, los clientes cuya industria no es Transporte se reportan a Triumph con tipo "other" en lugar de "carrier". Es independiente del switch de deudores de arriba.',
  TRIUMPH_SEND_ALL_INDUSTRIES_UPDATED: 'Configuración de Triumph actualizada',
  TRIUMPH_SEND_ALL_INDUSTRIES_UPDATE_FAILED: 'No se pudo actualizar la configuración de Triumph',
  TRIUMPH_SEND_ALL_INDUSTRIES_UNSAVED: 'Cambios sin guardar — presioná Guardar para aplicar.',
  TRIUMPH_SAVE: 'Guardar',
  TRIUMPH_SAVE_DIALOG_TITLE: 'Guardar configuración de Triumph',
  TRIUMPH_SAVE_DIALOG_BODY:
    'Cualquier switch que actives va a re-enviar inmediatamente a Triumph, en segundo plano, sus clientes/deudores GENERAL elegibles con tipo "other". Desactivar un switch NO revierte lo ya enviado — va a seguir como "other" en Triumph hasta que se edite o re-sincronice manualmente.',
  TRIUMPH_SAVE_DIALOG_CONFIRM: 'Continuar',
  TRIUMPH_SYNC_STATUS_TITLE: 'Estado de sincronización',
  TRIUMPH_TAB_CLIENTS: 'Clientes',
  TRIUMPH_TAB_DEBTORS: 'Deudores',
  TRIUMPH_TABLE_NAME: 'Nombre',
  TRIUMPH_TABLE_INDUSTRY: 'Industria',
  TRIUMPH_TABLE_TRIUMPH_ID: 'Triumph ID',
  TRIUMPH_TABLE_STATUS: 'Estado',
  TRIUMPH_TABLE_FAILURE_DATE: 'Último fallo',
  TRIUMPH_TABLE_REASON: 'Razón',
  TRIUMPH_TABLE_EMPTY: 'Aún no hay intentos de sincronización.',
  TRIUMPH_TABLE_LOAD_ERROR: 'No se pudo cargar el estado de sincronización. Reintentá si persiste.',
  FACTOR_GENIE_MESSAGE: 'La aplicación gratuita para factores de carga.',
  ANSONIA_MESSAGE: 'Empresa líder en informes crediticios.',
  OVERPASS_MESSAGE: 'Datos de FactorGenie Credit en el tab de Overpass del debtor.',
  INTEGRATION_AUTHORIZED: 'Integración autorizada',
  INTEGRATIONS: 'Integraciones',
  GMAIL_INTEGRATION: 'Integración de Gmail',
  GMAIL_ACCOUNT: 'Cuenta de Gmail',
  QUICKBOOKS_PUSH_CONFIRMATION_TITLE: 'Confirmar envío a Quickbooks',
  QUICKBOOKS_PUSH_RANGE_MESSAGE: 'Este envío cubrirá el siguiente rango en la zona horaria del factor:',
  QUICKBOOKS_PUSH_FIRST_RANGE_MESSAGE: 'Este es el primer envío. Incluirá todos los registros elegibles hasta:',
  QUICKBOOKS_PUSH_ONCE_PER_DAY: 'Este envío solo se puede hacer una vez al día.',
  QUICKBOOKS_FIRST_PUSH_START: 'Primer registro disponible',
  QUICKBOOKS_LAST_PUSH_BADGE: 'Último envío',
  QUICKBOOKS_ALREADY_PUSHED_TODAY: 'Quickbooks ya fue enviado hoy para este factor.',
  QUICKBOOKS_PUSH_CURRENCY_REQUIRED:
    'No puedes enviar a Quickbooks mientras esté seleccionado "Todas las monedas". Selecciona una moneda específica en el filtro de monedas para continuar.',
  ATOB_ONLINE_SETUP: 'Integration con AtoB',
  ATOB_DESCRIPTION:
    'AtoB es un servicio financiero moderno para la industria del transporte. Pagos instantáneos y seguros.',
  ATOB_ENABLED: 'Integración de AtoB habilitada.',
}
